import axios from 'axios'
import { ApiResponse, AsessFilterDto } from '../models/Base'
import { TableDto } from '../models/dto/SelfAssessment'
import { CreateSpeacialWithPersonRequestDto, SpecialAssessDto, SpecialAssessRequestDto } from '../models/dto/Special'

const API_URL = process.env.REACT_APP_API_URL
const ACTION_API_URL = `${API_URL}/special-assesses`


export function GetById(payload: number) {
    return axios.get<ApiResponse<SpecialAssessDto>>(`${ACTION_API_URL}/${payload}`)
}

export function Search(payload: AsessFilterDto) {
    return axios.post<ApiResponse<TableDto>>(`${ACTION_API_URL}/search`, payload)
}

export function Create(payload: SpecialAssessRequestDto) {
    return axios.post(`${ACTION_API_URL}`, payload)
}

export function Update(id: number, payload: SpecialAssessRequestDto) {
    return axios.put(`${ACTION_API_URL}/${id}`, payload)
}

export function CreateSpeacialWithPerson( payload:CreateSpeacialWithPersonRequestDto){
    return axios.post(`${ACTION_API_URL}/persons`, payload)
}